export default __webpack_public_path__ + "static/media/r1.6d737409.jpg";